var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFourth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 50,
    viewBox: "0 0 42.43 42.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #305549;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    className: "cls-1",
    cx: 21.21,
    cy: 21.21,
    r: 21.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.74,27.52v-3.55l8.13-11.62h4.91v11.37h2.11v3.81h-2.11v3.34h-4.4v-3.34H11.74Zm8.95-10.34l-4.32,6.53h4.32v-6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.66,18.72h-5.8c.04,.52,.21,.92,.5,1.19,.29,.28,.66,.41,1.09,.41,.64,0,1.09-.27,1.34-.81h2.73c-.14,.55-.39,1.04-.76,1.48-.37,.44-.82,.79-1.37,1.04-.55,.25-1.17,.38-1.84,.38-.82,0-1.55-.18-2.19-.53-.64-.35-1.14-.85-1.5-1.5-.36-.65-.54-1.41-.54-2.28s.18-1.63,.53-2.28c.35-.65,.85-1.15,1.49-1.5s1.38-.53,2.21-.53,1.53,.17,2.16,.51c.63,.34,1.12,.82,1.48,1.46,.35,.63,.53,1.36,.53,2.2,0,.24-.01,.49-.04,.75Zm-2.58-1.42c0-.44-.15-.79-.45-1.05-.3-.26-.67-.39-1.12-.39s-.79,.12-1.09,.38-.48,.6-.55,1.06h3.21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourth);
export default __webpack_public_path__ + "static/media/fourth.8a93168cc3e2209dcc3da5d022013a60.svg";
export { ForwardRef as ReactComponent };